import formbricks from '@formbricks/js';

declare global {
  interface Window {
    __formbricksInitialized?: boolean;
    __formbricksInitFailed?: boolean;
  }
}

const normalizeAppUrl = (value: string) => value.trim().replace(/\/+$/, '');

export function isFormbricksReady(): boolean {
  return typeof window !== 'undefined' && window.__formbricksInitialized === true;
}

export function initFormbricks(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.__formbricksInitialized) return true;
  if (window.__formbricksInitFailed) return false;

  const environmentId = import.meta.env.VITE_FORMBRICKS_ENVIRONMENT_ID as string | undefined;
  const appUrl = import.meta.env.VITE_FORMBRICKS_APP_URL as string | undefined;

  if (!environmentId || !appUrl) {
    // No throw: you want the app to still work even if surveys are not configured yet.
    console.warn(
      'Formbricks not configured. Missing VITE_FORMBRICKS_ENVIRONMENT_ID or VITE_FORMBRICKS_APP_URL.'
    );
    return false;
  }

  const normalizedAppUrl = normalizeAppUrl(appUrl);

  try {
    formbricks.setup({
      environmentId,
      appUrl: normalizedAppUrl,
    });
  } catch (error) {
    window.__formbricksInitFailed = true;
    console.warn('Formbricks failed to initialize. Surveys are disabled for this session.', error);
    return false;
  }

  window.__formbricksInitialized = true;
  return true;
}

export { formbricks };
